import { Context } from "../Engine";

export class ShadowMapRenderer {
    constructor(ctx: Context) {

    }

    render() {
        
    }
}